/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-09.
 * "Despachos" service
 *
 * If you need to remap data, this is the place to doit,
 * keep clean the actions.
 *
 * Handle errors here
 */
import { serializeParams } from '../common/helpers';
import request from './request';

const statuses = [
    { text: 'EN PROCESO', status: 'enproceso' },
    { text: 'PREALERTADO', status: 'prealertado' },
    { text: 'ALERTADO', status: 'alertado' },
    { text: 'DESPACHADO', status: 'despachado' },
    { text: 'CERRADO', status: 'cerrado' }
];

export const get = (url = '', params = {}) => {
    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return [];
            return error;
        });
    /*const mock = [...Array(150).keys()].map(() =>
        statuses[Math.floor(Math.random() * statuses.length)])
        .map((x, index) => { return { ...x, id: index }; });
    return Promise.resolve(mock);*/
};

export const post = (url = '', params = {}) => {
    return request().post(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const put = (url = '', params = {}) => {
    return request().put(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const patch = (url = '', params = {}) => {
    return request().patch(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const Delete = (url = '', params = {}) => {
    return request().delete(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};



// WEBPACK FOOTER //
// ./services/despachos.js